import W_ProgressBilling from '../W_ProgressBilling/W_ProgressBilling';
import styles from './W_PaymentTreeDonateBilling.module.css';

interface W_PaymentTreeDonateBillingProps {
  progress: number;
  totalDonations: number;
  cost: number;
  name: string;
  donorsCount: number;
}

export default function W_PaymentTreeDonateBilling({
  progress,
  totalDonations,
  cost,
  name,
  donorsCount,
}: W_PaymentTreeDonateBillingProps) {
  return (
    <div className={styles.wrapper}>
      <W_ProgressBilling
        progress={progress}
        totalDonations={totalDonations}
        cost={cost}
        name={name}
        donorsCount={donorsCount}
      />
    </div>
  );
}
